module.exports = __webpack_public_path__ + "img/send.db0c5e99.svg";